import React from 'react';
import { IconButton, Tooltip, Typography, Box, Chip } from '@mui/material';
import { Timer } from '@mui/icons-material';
import { useTimer } from '../hooks/useTimer';
import { formatTime } from '../../../../utils/formatting/timeFormatter';

/**
 * 计时器组件
 * 用于跟踪代码练习的时间
 */
function TimerWidget({ onTimerChange }) {
  const { timerRunning, elapsedTime, toggleTimer, resetTimer } = useTimer();

  React.useEffect(() => {
    if (onTimerChange) {
      onTimerChange({ running: timerRunning, elapsedTime });
    }
  }, [timerRunning, elapsedTime, onTimerChange]);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Tooltip title={timerRunning ? '暂停计时器' : '开始计时器'}>
        <IconButton
          size="small"
          onClick={toggleTimer}
          sx={{
            color: timerRunning ? 'primary.main' : 'text.secondary',
            '&:hover': {
              bgcolor: 'action.hover'
            }
          }}
        >
          <Timer />
        </IconButton>
      </Tooltip>
      <Chip
        label={
          <Typography variant="caption" sx={{ fontFamily: 'monospace', fontWeight: 600 }}>
            {formatTime(elapsedTime)}
          </Typography>
        }
        size="small"
        color={timerRunning ? 'primary' : 'default'}
        variant={timerRunning ? 'filled' : 'outlined'}
        onDelete={elapsedTime > 0 && !timerRunning ? resetTimer : undefined}
        sx={{
          height: '24px',
          fontSize: '0.75rem',
          '& .MuiChip-deleteIcon': {
            fontSize: '0.875rem',
            color: 'text.secondary'
          }
        }}
      />
    </Box>
  );
}

export default TimerWidget;

